import { Button, Box, Typography } from "@mui/material";
import { CreditCard } from "@mui/icons-material";
import { useState } from "react";
import GenericModal from "../GenericModal";
import PaymentAmountSelector from "./PaymentAmountSelector";
import styles from "./PaySchoolButton.module.css";
import { Vocabulary } from "../../Utils/Vocabulary";
import { generatePaymentUrl } from "../../Utils/PaymentUtils";
import { PAYMENT_TYPES } from "../../Utils/Constants";

interface PaySchoolButtonProps {
  order?: any;
  amountLeftToPay?: number;
  clientData: any;
}

export default function PaySchoolButton({
  order,
  amountLeftToPay = 0,
  clientData,
}: PaySchoolButtonProps) {
  const [openModal, setOpenModal] = useState(false);
  const [selectedAmount, setSelectedAmount] = useState<number | null>(null);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedAmount(null);
  };

  const handlePaymentConfirm = () => {
    if (selectedAmount !== null) {
      const amount = selectedAmount;

      // save payment data in local storage
      window.localStorage.setItem("processingOrderId", order?._id);
      window.localStorage.setItem("paymentType", PAYMENT_TYPES.SCHOOL_PAYMENTS);

      generatePaymentUrl({
        clientId: clientData?._id,
        clientData,
        amount,
        orderDescription: `${Vocabulary.paySchool}`,
        saveOrderId: false,
      });

      handleCloseModal();
    }
  };

  const modalActions = (
    <>
      <Button
        variant="outlined"
        color="inherit"
        fullWidth
        onClick={handleCloseModal}
      >
        {Vocabulary.cancel}
      </Button>
      <Button
        variant="contained"
        color="primary"
        fullWidth
        onClick={handlePaymentConfirm}
        disabled={selectedAmount === null}
      >
        {Vocabulary.confirm}
      </Button>
    </>
  );

  return (
    <>
      <Button
        variant="contained"
        size="small"
        color="primary"
        startIcon={<CreditCard />}
        onClick={handleOpenModal}
        className={styles.button}
      >
        {Vocabulary.paySchool}
      </Button>

      <GenericModal
        open={openModal}
        onClose={handleCloseModal}
        title={Vocabulary.paySchool}
        actions={modalActions}
        width="800px"
      >
        <Box className={styles.modalContent}>
          <Box className={styles.modalInfo}>
            <Typography className={styles.modalInfoText}>
              {Vocabulary.service}: {order?.product?.name}
            </Typography>
          </Box>
          <PaymentAmountSelector
            key={String(openModal)}
            amountLeftToPay={amountLeftToPay}
            onAmountSelect={setSelectedAmount}
          />
          <Typography className={styles.paymentWarning}>
            {Vocabulary.paymentRedirectWarning}
          </Typography>
        </Box>
      </GenericModal>
    </>
  );
}
